import React, { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import successImg from "../../assets/images/userprofile/successImg.png";
import { useFormik } from "formik";
import * as Yup from "yup";
import { axiosInstance_user } from "../../axiosInstance-user";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import { useLocation } from "react-router-dom";
import CircularProgress from "@mui/material/CircularProgress";
import { ToastContainer, toast } from "react-toastify";
const animatedComponents = makeAnimated();

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 300,
  bgcolor: "background.paper", //box color
  border: "1px solid white", //box border
  boxShadow: 24,
  pt: 2,
  px: 0,
  pb: 3,
};
// knownLaguages styles
const customStyles = {
  control: (provided, state) => ({
    ...provided,
    width: "100%",
    padding: "2px", // Slight padding only for inside control
    border: "1px solid #e4e4e4",
    backgroundColor: "#fbfbfb",
    color: "#2a2a2a",
    borderRadius: "10px",
    fontSize: "16px",
    fontWeight: 400,
    boxShadow: state.isFocused ? "0 0 0 1px #e4e4e4" : "none",
    "&:hover": {
      borderColor: "#ccc",
    },
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected
      ? "#e4e4e4"
      : state.isFocused
      ? "#f2f2f2"
      : "#fff",
    color: "#2a2a2a",
    fontSize: "16px",
    fontWeight: 400,
  }),
  multiValue: (provided) => ({
    ...provided,
    backgroundColor: "#e0e0e0",
    borderRadius: "5px",
    padding: "2px 4px",
  }),
  multiValueLabel: (provided) => ({
    ...provided,
    color: "#2a2a2a",
    fontSize: "14px",
  }),
  multiValueRemove: (provided) => ({
    ...provided,
    color: "#2a2a2a",
    ":hover": {
      backgroundColor: "#d3d3d3",
      color: "#000",
    },
  }),
};
export function OtherInfo() {
  const [loading, setLoading] = useState(false);
  const location = useLocation();
  const userId = location.state?.id;
  console.log("userId", userId);

  const [knownLaguages, setKnownLaguages] = useState([]);

  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const formik = useFormik({
    initialValues: {
      lite_logins: [],
      known_languages: [],
      about_family: "",
      about_career: "",
      nationality: "",
      complexion: "",
      drinking: "",
      smoking: "",
      diet: "",
      pets: "",
      talents: "",
      wanderlust: false,
    },
    enableReinitialize: true,

    onSubmit: async (values) => {
      try {
        setLoading(true);
        console.log("EditUser", values);
        const formData = new FormData();

        // --- Handle lite_logins (e.g. ['Instagram', 'LinkedIn']) ---
        const liteLoginsArray = Array.isArray(values.lite_logins)
          ? values.lite_logins
          : String(values.lite_logins || "")
              .split(",")
              .map((item) => item.trim())
              .filter((item) => item !== "");

        formData.append(
          "profile[lite_logins]",
          JSON.stringify(liteLoginsArray)
        );

        // --- Handle known_languages (e.g. [{value: 1, label: 'English'}]) ---
        const knownLanguagesArray = (values.known_languages || [])
          .map((lang) => lang?.value)
          .filter((val) => val != null);

        formData.append(
          "profile[known_languages]",
          JSON.stringify(knownLanguagesArray)
        );

        // --- Other profile fields ---
        formData.append("profile[about_family]", values.about_family || "");
        formData.append("profile[about_career]", values.about_career || "");
        formData.append("profile[complexion]", Number(values.complexion) || 0);
        formData.append("profile[diet]", Number(values.diet) || 0);
        formData.append("profile[drinking]", Number(values.drinking) || 0);
        formData.append("profile[pets]", Number(values.pets) || 0);
        formData.append("profile[smoking]", Number(values.smoking) || 0);
        formData.append(
          "profile[nationality]",
          Number(values.nationality) || 0
        );
        formData.append("profile[talents]", values.talents || "");
        formData.append("profile[wanderlust]", values.wanderlust || "");

        const response = await axiosInstance_user.patch(
          `/users-profiles/${userId}/`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );

        if (response.data.status === "success") {
          setLoading(false); // Stop loader
          handleOpen();
           setTimeout(() => {
            handleClose();
          },2000);
          LoadUserProfile(userId);
        }
      } catch (error) {
        toast.error(error.response?.data?.message || "");
        console.error("Error while updating", error);
      }finally {
        setLoading(false);
      }
    },
  });
  // get user data
  async function LoadUserProfile(userId) {
    try {
      const response = await axiosInstance_user.get(
        `/users-profiles/${userId}`
      );
      if (response.data.status === "success") {
        // getting few fields from user and few from profile
        const user = response.data.data;
        const profile = user.profile || {};

        // const selectedLanguages = (profile.known_languages || [])
        //   .map((id) => knownLaguages.find((lang) => lang.value === id))
        //   .filter(Boolean); // remove nulls or default cross
        const selectedLanguages = (profile.known_languages || [])
          .map((id) =>
            knownLaguages.find((lang) => Number(lang.value) === Number(id))
          )
          .filter(Boolean);

        formik.setValues({
          lite_logins: profile.lite_logins || [],
          known_languages: selectedLanguages || [],
          about_family: profile.about_family || "",
          about_career: profile.about_career || "",
          nationality: profile.nationality || "",
          complexion: profile.complexion || "",
          drinking: profile.drinking || "",
          smoking: profile.smoking || "",
          diet: profile.diet || "",
          pets: profile.pets || "",
          talents: profile.talents || "",
          wanderlust: profile.wanderlust ?? false,
          password: "nathicharami", // required field
        });
      }
    } catch (err) {
      
      console.error("Failed to load profile:", err);
    }
  }
  // useEffect(() => {
  //   if (userId) {
  //     LoadUserProfile(userId);
  //   }
  // }, [userId]);
  //  Once languages are loaded, fetch user profile
  useEffect(() => {
    if (knownLaguages.length > 0 && userId) {
      LoadUserProfile(userId);
    }
  }, [knownLaguages, userId]);
  async function LoadKnownLanguages() {
    try {
      const response = await axiosInstance_user.get("/dropdown/choices");

      if (response.status === 200 && response.data) {
        // react-select expects this format for each option eg. { value: 'someValue', label: 'Display Label' }
        const languages = response.data.mother_tongue.map((lang) => ({
          value: lang.id,
          label: lang.name,
        }));
        setKnownLaguages(languages);
      } else {
        console.error("Unexpected response format or status", response);
      }
    } catch (error) {
      console.error("Failed to load religion data:", error.message);
    }
  }
  useEffect(() => {
    LoadKnownLanguages();
  }, []);
  const handleChange = (selectedOptions) => {
    formik.setFieldValue("known_languages", selectedOptions || []);
  };
  return (
    <form onSubmit={formik.handleSubmit}>
      {loading && (
        <div className="loader-overlay">
          <CircularProgress style={{ color: "#f24464" }} />
        </div>
      )}
      <div>
        {/* Row 1 */}
        <div className="other-subcontainer">
          <div>
            <div className="other-label">Lite Logins</div>
            <div className="other-input">
              <input
                type="text"
                name="lite_logins"
                placeholder="Enter comma-separated values"
                value={formik.values.lite_logins}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              />
              {formik.touched.lite_logins && formik.errors.lite_logins && (
                <div className="text-danger">{formik.errors.lite_logins}</div>
              )}
            </div>
          </div>
          <div>
            <div className="other-label">Known Languages</div>

            <div className="other-input">
              {/* <input
                   type="text"
                   name="known_languages"
                   placeholder="Enter known languages"
                   value={formik.values.known_languages}
                   onChange={formik.handleChange}
                   onBlur={formik.handleBlur}
                 /> */}
              <Select
                closeMenuOnSelect={false}
                components={animatedComponents}
                isMulti
                name="known_languages"
                options={knownLaguages}
                value={formik.values.known_languages}
                onChange={handleChange}
                onBlur={() => formik.setFieldTouched("known_languages", true)}
                styles={customStyles}
              />

              {formik.touched.known_languages &&
                formik.errors.known_languages && (
                  <div className="text-danger">
                    {formik.errors.known_languages}
                  </div>
                )}
            </div>
          </div>
        </div>

        {/* Row 2 */}
        <div className="other-subcontainer">
          <div>
            <div className="other-label">About Family</div>
            <div className="other-input">
              <textarea
                name="about_family"
                placeholder="Type Here"
                rows={4}
                value={formik.values.about_family}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              ></textarea>
              {formik.touched.about_family && formik.errors.about_family && (
                <div className="text-danger">{formik.errors.about_family}</div>
              )}
            </div>
          </div>
          <div>
            <div className="other-label">About Career</div>
            <div className="other-input">
              <textarea
                name="about_career"
                placeholder="Type Here"
                rows={4}
                value={formik.values.about_career}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              ></textarea>
              {formik.touched.about_career && formik.errors.about_career && (
                <div className="text-danger">{formik.errors.about_career}</div>
              )}
            </div>
          </div>
        </div>

        {/* Row 3 */}
        <div className="other-subcontainer">
          <div>
            <div className="other-label">Nationality</div>
            <div className="other-input">
              <input
                type="text"
                name="nationality"
                placeholder="Enter Nationality"
                value={formik.values.nationality}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              />
              {formik.touched.nationality && formik.errors.nationality && (
                <div className="text-danger">{formik.errors.nationality}</div>
              )}
            </div>
          </div>
          <div>
            <div className="other-label">Complexion</div>
            <div className="other-input">
              <select
                className="dropdown-btnOther"
                name="complexion"
                value={formik.values.complexion}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              >
                <option value="" selected disabled>
                  Select
                </option>
                <option value="1">Fair</option>
                <option value="2">Light</option>
                <option value="3">Medium</option>
                <option value="4">Olive</option>
                <option value="5">Brown</option>
                <option value="6">Dark</option>
              </select>
              {formik.touched.complexion && formik.errors.complexion && (
                <div className="text-danger">{formik.errors.complexion}</div>
              )}
            </div>
          </div>
        </div>

        {/* Row 4 */}
        <div className="other-subcontainer">
          <div>
            <div className="other-label">Drinking</div>
            <select
              className="dropdown-btnOther"
              name="drinking"
              value={formik.values.drinking}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            >
              <option value="" selected disabled>
                Select
              </option>
              <option value="1">Non Drinker</option>
              <option value="2">Regular</option>
              <option value="3">Planning to quit</option>
              <option value="4">Socially</option>
              <option value="5">Occasionally</option>
            </select>
            {formik.touched.drinking && formik.errors.drinking && (
              <div className="text-danger">{formik.errors.drinking}</div>
            )}
          </div>
          <div>
            <div className="other-label">Smoking</div>
            <select
              className="dropdown-btnOther"
              name="smoking"
              value={formik.values.smoking}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            >
              <option value="" selected disabled>
                Select
              </option>
              <option value="1">Yes</option>
              <option value="2">No</option>
              <option value="3">Planning to quit</option>
              <option value="4">Occasionally</option>
              <option value="5">Regularly</option>
            </select>
            {formik.touched.smoking && formik.errors.smoking && (
              <div className="text-danger">{formik.errors.smoking}</div>
            )}
          </div>
        </div>

        {/* Row 5 */}
        <div className="other-subcontainer">
          <div>
            <div className="other-label">Diet</div>
            <select
              className="dropdown-btnOther"
              name="diet"
              value={formik.values.diet}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            >
              <option value="" selected disabled>
                Select
              </option>
              <option value="1">Vegetarian</option>
              <option value="2">Non Vegetarian</option>
              <option value="3">Eggetarian</option>
              <option value="4">Vegan</option>
            </select>
            {formik.touched.diet && formik.errors.diet && (
              <div className="text-danger">{formik.errors.diet}</div>
            )}
          </div>
          <div>
            <div className="other-label">Pets</div>
            <select
              className="dropdown-btnOther"
              name="pets"
              value={formik.values.pets}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            >
              <option value="" selected disabled>
                Select
              </option>
              <option value="1">Don't want</option>
              <option value="2">Cats</option>
              <option value="3">Have pets</option>
              <option value="4">Undecided</option>
            </select>
            {formik.touched.pets && formik.errors.pets && (
              <div className="text-danger">{formik.errors.pets}</div>
            )}
          </div>
        </div>

        {/* Row 6 */}
        <div className="other-subcontainer">
          <div>
            <div className="other-label">Talents</div>
            <div className="other-input">
              <input
                type="text"
                name="talents"
                placeholder="Enter Talents"
                value={formik.values.talents}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              />
              {formik.touched.talents && formik.errors.talents && (
                <div className="text-danger">{formik.errors.talents}</div>
              )}
            </div>
          </div>
          <div className="checkbox-container">
            <input
              type="checkbox"
              name="wanderlust"
              checked={formik.values.wanderlust}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            />
            <label className="family-label">Wanderlust</label>
            {formik.touched.wanderlust && formik.errors.wanderlust && (
              <div className="text-danger">{formik.errors.wanderlust}</div>
            )}
          </div>
        </div>

        {/* Submit Button and Modal */}
        <div className="btnBasicSave">
          <Button type="submit">Save Changes</Button>
        </div>

        <Modal
          open={open}
          onClose={handleClose}
          closeAfterTransition
          aria-labelledby="transition-modal-title"
          aria-describedby="transition-modal-description"
        >
          <Fade in={open}>
            <Box sx={style} className="modal-box">
              <img src={successImg} alt="Success" />
              <Typography
                id="transition-modal-title"
                variant="h6"
                component="h2"
              >
                Thank You
              </Typography>
              <Typography id="transition-modal-description" sx={{ mt: 2 }}>
                Other information has been successfully updated
              </Typography>
            </Box>
          </Fade>
        </Modal>
      </div>
    </form>
  );
}
